import {defineStore} from 'pinia';
import axios from 'axios';

export const useEPStore = defineStore('ep', {
	state: () => ({
		spinner: false
	}),
	actions: {
		analyze(url, type) {
			return axios.get('/tools/analyze', {params: {url, type}});
		},
		fetchEvents(date, startTime, endTime, mode = 'legacy') {
			return axios.get(`/events/fetch/${date}`, {params: {date, startTime, endTime, mode}});
		},
		checkLiveBets() {
			return axios.get('/bets/check');
		}
	}
});
